import Vue from 'vue';
import {
  faBars,
  faLock,
  faUser,
  faSearch,
  faCheckSquare,
  faTicket,
  faSquare,
  faMinusSquare,
  faLongArrowUp,
  faLongArrowRight,
  faAngleLeft,
  faAngleRight,
  faAngleDown,
  faList,
  faShoppingCart,
  faUserFriends,
  faEdit,
  faCogs,
  faPlus,
  faMinus,
  faTrash,
  faArrows,
  faLevelUp,
  faTimes,
  faDotCircle,
  faCircle,
  faCog,
  faBullhorn,
  faCalendarWeek,
  faRandom,
  faPrint,
  faAngleDoubleRight,
  faCommentAlt,
  faCopy,
  faPhone,
  faEnvelope,
  faMapMarkerAlt,
  faCloudUpload,
  faStore,
  faFilter,
  faUndo,
  faQrcode,
  faBoxAlt,
  faCheck,
  faPuzzlePiece,
  faTruck,
  faBallotCheck,
} from '@fortawesome/pro-light-svg-icons';
import { faExclamationTriangle } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

Vue.component('font-awesome-icon', FontAwesomeIcon);

export default {
  expand: {
    component: FontAwesomeIcon,
    props: { icon: faAngleDown },
  },
  subgroup: {
    component: FontAwesomeIcon,
    props: { icon: faAngleDown },
  },
  menu: {
    component: FontAwesomeIcon,
    props: {
      icon: faBars,
      size: '9x',
    },
  },
  lock: {
    component: FontAwesomeIcon,
    props: { icon: faLock },
  },
  user: {
    component: FontAwesomeIcon,
    props: { icon: faUser },
  },
  copy: {
    component: FontAwesomeIcon,
    props: { icon: faCopy },
  },
  ticket: {
    component: FontAwesomeIcon,
    props: { icon: faTicket },
  },
  pohoda: {
    component: FontAwesomeIcon,
    props: { icon: faCog },
  },
  search: {
    component: FontAwesomeIcon,
    props: { icon: faSearch },
  },
  checkboxOn: {
    component: FontAwesomeIcon,
    props: { icon: faCheckSquare },
  },
  checkboxOff: {
    component: FontAwesomeIcon,
    props: { icon: faSquare },
  },
  checkboxIndeterminate: {
    component: FontAwesomeIcon,
    props: { icon: faMinusSquare },
  },
  sort: {
    component: FontAwesomeIcon,
    props: { icon: faLongArrowUp },
  },
  arrowRight: {
    component: FontAwesomeIcon,
    props: { icon: faLongArrowRight },
  },
  next: {
    component: FontAwesomeIcon,
    props: { icon: faAngleRight },
  },
  prev: {
    component: FontAwesomeIcon,
    props: { icon: faAngleLeft },
  },
  dropdown: {
    component: FontAwesomeIcon,
    props: { icon: faAngleDown },
  },
  catalog: {
    component: FontAwesomeIcon,
    props: { icon: faList },
  },
  orders: {
    component: FontAwesomeIcon,
    props: { icon: faShoppingCart },
  },
  customers: {
    component: FontAwesomeIcon,
    props: { icon: faUserFriends },
  },
  content: {
    component: FontAwesomeIcon,
    props: { icon: faEdit },
  },
  settings: {
    component: FontAwesomeIcon,
    props: { icon: faCogs },
  },
  plus: {
    component: FontAwesomeIcon,
    props: { icon: faPlus },
  },
  minus: {
    component: FontAwesomeIcon,
    props: { icon: faMinus },
  },
  delete: {
    component: FontAwesomeIcon,
    props: { icon: faTrash },
  },
  move: {
    component: FontAwesomeIcon,
    props: { icon: faArrows },
  },
  levelUp: {
    component: FontAwesomeIcon,
    props: { icon: faLevelUp },
  },
  clear: {
    component: FontAwesomeIcon,
    props: { icon: faTimes },
  },
  radioOn: {
    component: FontAwesomeIcon,
    props: { icon: faDotCircle },
  },
  radioOff: {
    component: FontAwesomeIcon,
    props: { icon: faCircle },
  },
  marketing: {
    component: FontAwesomeIcon,
    props: { icon: faBullhorn },
  },
  event: {
    component: FontAwesomeIcon,
    props: { icon: faCalendarWeek },
  },
  random: {
    component: FontAwesomeIcon,
    props: { icon: faRandom },
  },
  print: {
    component: FontAwesomeIcon,
    props: { icon: faPrint },
  },
  detail: {
    component: FontAwesomeIcon,
    props: { icon: faAngleDoubleRight },
  },
  phone: {
    component: FontAwesomeIcon,
    props: { icon: faPhone },
  },
  envelope: {
    component: FontAwesomeIcon,
    props: { icon: faEnvelope },
  },
  chat: {
    component: FontAwesomeIcon,
    props: { icon: faCommentAlt },
  },
  mapMarker: {
    component: FontAwesomeIcon,
    props: { icon: faMapMarkerAlt },
  },
  upload: {
    component: FontAwesomeIcon,
    props: { icon: faCloudUpload },
  },
  store: {
    component: FontAwesomeIcon,
    props: { icon: faStore },
  },
  filter: {
    component: FontAwesomeIcon,
    props: { icon: faFilter },
  },
  undo: {
    component: FontAwesomeIcon,
    props: { icon: faUndo },
  },
  qrCode: {
    component: FontAwesomeIcon,
    props: { icon: faQrcode },
  },
  box: {
    component: FontAwesomeIcon,
    props: { icon: faBoxAlt },
  },
  check: {
    component: FontAwesomeIcon,
    props: { icon: faCheck },
  },
  puzzle: {
    component: FontAwesomeIcon,
    props: { icon: faPuzzlePiece },
  },
  truck: {
    component: FontAwesomeIcon,
    props: { icon: faTruck },
  },
  triangleExclamation: {
    component: FontAwesomeIcon,
    props: { icon: faExclamationTriangle },
  },
  ballotCheck: {
    component: FontAwesomeIcon,
    props: { icon: faBallotCheck },
  },
};
